import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_DISCOUNTS_CREATE,
  IN_ROOM_DINING_DISCOUNTS_EDIT,
  IN_ROOM_DINING_DISCOUNTS_VIEW,
  IN_ROOM_DINING_SELECTED_ITEM_ALREADY_OCCUPIED_ERROR,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  fetchAllInRoomDining,
  inRoomDiningDiscountsSelector,
  inRoomDiningItemsSelector,
  setInRoomDiningDiscounts,
} from '../../../servicesSlice';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import {
  activateInRoomDiningDiscount,
  deactivateInRoomDiningDiscount,
  deleteInRoomDiningDiscount,
  deleteSelectedItems,
  updateSelectedItemsStatus,
  uploadIRDDiscountsByCSV,
} from '../../../../../utils/ServicesAPIUtils';
import {
  allHotelsSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  validateAlphanumeric,
  generateConfirmationMessage,
  selectedCheckList,
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
} from '../../../../../utils/formUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import moment from 'moment';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const initialState = {
  name: '',
  description: '',
  status: false,
};

const DiscountsListView = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    restaurantId,
    inRoomDiningLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;

  const selectedHotel = useSelector(allHotelsSelector);
  const inRoomDiningDiscounts = useSelector(inRoomDiningDiscountsSelector);
  const inRoomDiningItems = useSelector(inRoomDiningItemsSelector);
  const dispatch = useDispatch();
  const currency = useSelector(selectedHotelCurrencySelector);
  const [discountsList, setDiscountsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const [warningPopup, setWarningPopup] = useState(initialState);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const dragDisabled = !!searchText || discountsList?.length <= 1;
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  useEffect(() => {
    setDiscountsList((prevList) => {
      return inRoomDiningDiscounts?.map((discount) => {
        const isChecked = selectedCheckList(prevList, discount.id);
        return {
          ...discount,
          isChecked: isChecked,
        };
      });
    });
    setLoading(false);
    setSearchText('');
  }, [inRoomDiningDiscounts]);

  const getCheckedDiscountList = discountsList?.filter((discount) => discount?.isChecked);

  const listOfDiscountIds = getCheckedDiscountList?.map((discount) => discount.id);

  const selectedDiscountLength = getCheckedDiscountList?.length;

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(discountsList, 'isChecked');
    const filteredRows = await inRoomDiningDiscounts.filter((discount) => {
      return discount.name.toLowerCase().includes(searchText.toLowerCase());
    });
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setDiscountsList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedDiscountLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setDiscountsList(ResetFilterList);
    }
  };

  useEffect(() => {
    updateSelectedModule(discountsList, setActionMenuList, setIsAllSelected);
  }, [discountsList]);

  useEffect(() => {
    if (inRoomDiningLoader || discountsList?.length === 0) return;
    const totalItems = discountsList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [discountsList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const onOpenDrawer = (event, type) => {
    if (selectedDiscountLength) {
      setDiscountsList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.discount);
    handleClose();
  };

  const onViewDetails = (discountItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(IN_ROOM_DINING_DISCOUNTS_VIEW, true, discountItem);
    }
  };

  const onViewDetailsFromMenu = (e) => {
    if (selectedValue.discount)
      onViewToggle(IN_ROOM_DINING_DISCOUNTS_VIEW, true, selectedValue.discount);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      discount: null,
    });
  };

  const handleCellMenuClick = (event, discount) => {
    if (selectedDiscountLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: discount.id,
        name: discount.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        discount,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onClickDelete = (event) => {
    event.stopPropagation();
    if (checkUsageItems()) {
      setWarningPopup({
        name: selectedValue.name,
        description: 'The selected Discount cannot be deleted as it is being added to a Menu/Item',
        status: true,
      });
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'This action cannot be reversed',
        status: true,
        anchorEl: null,
      }));
    }
  };

  const checkUsageItems = () => {
    return inRoomDiningItems.some(
      (ird) => ird.discount && ird.discount.discount && ird.discount.discount === selectedValue.id,
    );
  };

  const onDeleteDiscount = async () => {
    try {
      dispatch(stepUpLoaderCount());
      if (hotelId && selectedValue.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const payload = {
          id: selectedValue.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        await deleteInRoomDiningDiscount(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager('success', 'Discount deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        switch (e.graphQLErrors[0].message) {
          case IN_ROOM_DINING_SELECTED_ITEM_ALREADY_OCCUPIED_ERROR:
            setWarningPopup({
              name: selectedValue.name,
              description:
                'The selected Discount cannot be deleted as it is being added to a Menu/Item',
              status: true,
            });
            break;
          default:
            notificationManager('danger', e.graphQLErrors[0].message);
            break;
        }
      } else {
        notificationManager('danger', 'Failed to delete Discount');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onToggleStatus = async (e) => {
    e.stopPropagation();
    if (selectedValue.discount && hotelId) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        const payload = {
          id: selectedValue.discount.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        selectedValue.discount.status
          ? await deactivateInRoomDiningDiscount(payload, language)
          : await activateInRoomDiningDiscount(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager(
          'success',
          `Discount ${selectedValue.discount.status ? 'deactivated' : 'activated'} successfully`,
        );
      } catch (e) {
        if (e.graphQLErrors) {
          notificationManager('danger', e.graphQLErrors[0].message);
        } else {
          notificationManager('danger', 'Failed to update Discount status');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = (event) => {
    handleClose();
  };

  const onCloseWarning = () => {
    handleClose();
    setWarningPopup(initialState);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllInRoomDining(hotelId, restaurantId));
    setCsvUploadStatus(null);
    setUploadState(false);
  };
  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const isNumber = (n) => /^\d+(\.\d+)?$/.test(String(n || '').trim());

  const SCHEDULE_PART_REGEX = /^(\d{2}-\d{2}-\d{4})T(\d{1,2}:\d{2})$/;

  const validateScheduleErrors = (data) => {
    if (!data || !data.trim()) return [];
    const s = data.trim();
    if (s.toLowerCase() === 'always active') return [];
    const parts = s.split('/');
    if (parts.length !== 2) return ['"Schedule" format is invalid (use "Always Active" or "DD-MM-YYYYTHH:mm/DD-MM-YYYYTHH:mm")'];
    const fromMatch = parts[0].trim().match(SCHEDULE_PART_REGEX);
    const tillMatch = parts[1].trim().match(SCHEDULE_PART_REGEX);
    if (!fromMatch || !tillMatch) return ['"Schedule" format is invalid (use "DD-MM-YYYYTHH:mm/DD-MM-YYYYTHH:mm")'];
    const fromDate = moment(fromMatch[1], 'DD-MM-YYYY', true);
    const tillDate = moment(tillMatch[1], 'DD-MM-YYYY', true);
    if (!fromDate.isValid()) return ['"Schedule" has invalid From date'];
    if (!tillDate.isValid()) return ['"Schedule" has invalid Till date'];
    const fromTime = fromMatch[2].padStart(5, '0');
    const tillTime = tillMatch[2].padStart(5, '0');
    const errors = [];
    if (fromDate.startOf('day').isBefore(moment().startOf('day'))) {
      errors.push('"Schedule" From date cannot be in the past');
    }
    if (tillDate.startOf('day').isBefore(moment().startOf('day'))) {
      errors.push('"Schedule" Till date cannot be in the past');
    }
    const fromDateClone = moment(fromMatch[1], 'DD-MM-YYYY', true);
    const tillDateClone = moment(tillMatch[1], 'DD-MM-YYYY', true);
    if (fromDateClone.isAfter(tillDateClone, 'day')) {
      errors.push('"Schedule" From date must be before or equal to Till date');
    } else if (fromDateClone.isSame(tillDateClone, 'day')) {
      if (fromTime >= tillTime) {
        errors.push('"Schedule" Till time must be after From time when dates are the same');
      }
    }
    return errors;
  };

  const isValidStatus = (status) => {
    const tempStatus = status.toLowerCase().trim();
    return tempStatus === 'yes' || tempStatus === 'no';
  };

  const toStr = (v) => (v == null ? '' : String(v));

  const handleCsvFileData = (itemsLists) => {
    try {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filteredItemList = itemsLists.filter((row) => !isTemplateInstructionRow(row));
    if (filteredItemList.length === 0) {
      setValidationErrors(['No data rows found in the uploaded file.']);
      setCsvValidateError(true);
      return;
    }
    const databaseNames = new Set((discountsList || []).map(ch => ch?.name?.trim()?.toLowerCase()).filter(Boolean));
    const databaseCodes = new Set((discountsList || []).map(ch => ch?.code?.trim()?.toLowerCase()).filter(Boolean));

    const nameFreq = Object.create(null);
    const codeFreq = Object.create(null);

    filteredItemList.forEach(item => {
      const nK = toStr(item?.discountName).trim().toLowerCase();
      const cK = toStr(item?.discountCode).trim().toLowerCase();
      if (nK) nameFreq[nK] = (nameFreq[nK] || 0) + 1;
      if (cK) codeFreq[cK] = (codeFreq[cK] || 0) + 1;
    });

    const fileDupNames = new Set(Object.keys(nameFreq).filter(k => nameFreq[k] > 1));
    const fileDupCodes = new Set(Object.keys(codeFreq).filter(k => codeFreq[k] > 1));

    const errors = [];
    const newItems = [];
    filteredItemList.forEach((item) => {
      const rowNum = item.__rowNum || '?';
      const rowErrors = [];
      const discountName = toStr(item.discountName).trim();
      const discountCode = toStr(item.discountCode).trim();
      const discountValue = toStr(item.discountValue).trim();
      const maximumDiscount = toStr(item.maximumDiscount).trim();
      const schedule = toStr(item.schedule).trim();
      const active = toStr(item.active).trim();
      if (!discountName) {
        rowErrors.push('"Discount Name" is empty');
      } else {
        if (discountName.length > 100) rowErrors.push('"Discount Name" exceeds 100 characters');
      }
      if (!discountCode) {
        rowErrors.push('"Discount Code" is empty');
      } else {
        if (discountCode.length > 8) rowErrors.push('"Discount Code" exceeds 8 characters');
        if (!validateAlphanumeric(discountCode)) rowErrors.push('"Discount Code" must be alphanumeric');
      }
      if (!discountValue) {
        rowErrors.push('"Discount Value" is empty');
      } else if (!isNumber(discountValue)) {
        rowErrors.push('"Discount Value" must be a valid number');
      } else {
        const val = parseInt(discountValue);
        if (val < 1) rowErrors.push('"Discount Value" must be at least 1');
        if (val > 100) rowErrors.push('"Discount Value" must not exceed 100');
      }
      if (!maximumDiscount) {
        rowErrors.push('"Maximum Discount" is empty');
      } else if (!isNumber(maximumDiscount)) {
        rowErrors.push('"Maximum Discount" must be a valid number');
      } else {
        const maxVal = parseInt(maximumDiscount);
        if (maxVal < 1) rowErrors.push('"Maximum Discount" must be at least 1');
        if (maxVal > 99999999) rowErrors.push('"Maximum Discount" must not exceed 99999999');
      }
      if (schedule) {
        const scheduleErrs = validateScheduleErrors(schedule);
        scheduleErrs.forEach((e) => rowErrors.push(e));
      }
      if (active && !isValidStatus(active)) rowErrors.push('"Active" must be Yes or No');
      
      const nK = discountName.toLowerCase();
      const cK = discountCode.toLowerCase();
      const nameExists = nK && (databaseNames.has(nK) || fileDupNames.has(nK));
      const codeExists = cK && (databaseCodes.has(cK) || fileDupCodes.has(cK));

      if (nameExists || codeExists) {
        const reasons = [];
        if (nameExists) reasons.push(`name '${discountName}'`);
        if (codeExists) reasons.push(`code '${discountCode}'`);
        rowErrors.push(`Already exists or duplicated in file (${reasons.join(' and ')})`);
      }

      if (rowErrors.length > 0) {
        errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
      } else {
        newItems.push(item);
      }
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
      return;
    }

    if (newItems.length > 0) {
      const listToUpload = newItems.map((item) => {
        const schedule = toStr(item.schedule).trim();
        let payload = {
          hotelId,
          code: toStr(item?.discountCode).trim(),
          name: toStr(item?.discountName).trim(),
          status: toStr(item?.active).trim().toUpperCase() === 'YES' ? true : false,
          upto: toStr(item?.maximumDiscount).trim(),
          value: toStr(item?.discountValue).trim(),
          disclaimer: toStr(item.disclaimer).trim(),
          description: toStr(item.description).trim(),
          restaurantId,
        };
        if (!schedule || schedule.toLowerCase() === 'always active') {
          payload.schedule = { always: true };
        } else {
          const parts = schedule.split('/');
          const fromMatch = parts[0].trim().match(SCHEDULE_PART_REGEX);
          const tillMatch = parts[1].trim().match(SCHEDULE_PART_REGEX);
          if (fromMatch && tillMatch) {
            payload.schedule = {
              always: false,
              from: { date: fromMatch[1], time: fromMatch[2].padStart(5, '0') },
              till: { date: tillMatch[1], time: tillMatch[2].padStart(5, '0') },
            };
          } else {
            payload.schedule = { always: true };
          }
        }
        return payload;
      });
      setValidationErrors([]);
      setCsvValidateError(false);
      handleCsvDataSubmit(listToUpload);
    } else {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
    }
    } catch (e) {
      setValidationErrors([`Unexpected error while processing file: ${e.message}`]);
      setCsvValidateError(true);
    }
  };

  const handleCsvDataSubmit = async (payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      dispatch(stepUpLoaderCount());
      const payload = {
        isReplace: false,
        hotelId: hotelId,
        discounts: payloadLists,
        restaurantId,
      };
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const res = await uploadIRDDiscountsByCSV(payload, language);
      if (res?.data?.uploadIRDDiscountByCSV?.status === 'Success') {
        setCsvUploadStatus('success');
      } else {
        const serverMsg = res?.data?.uploadIRDDiscountByCSV?.message || 'The server rejected the upload. Please verify your data and try again.';
        setCsvUploadErrorMsg(serverMsg);
        setCsvUploadStatus('server-error');
      }
    } catch (e) {
      const errMsg = e?.graphQLErrors?.[0]?.message || e?.message || 'An unexpected error occurred while uploading. Please try again.';
      setCsvUploadErrorMsg(errMsg);
      setCsvUploadStatus('server-error');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const generateHeaders = [
    { label: 'Discount Name', key: 'name' },
    { label: 'Discount Code', key: 'code' },
    { label: 'Discount Value', key: 'value' },
    { label: 'Maximum Discount', key: 'upto' },
    { label: 'Disclaimer', key: 'disclaimer' },
    { label: 'Description', key: 'description' },
    { label: 'Active', key: 'active' },
    { label: 'Schedule', key: 'schedules' },
  ];

  const generateSchedule = (data) => {
    return `${data.from?.date}T${data.from?.time}/${data.till?.date}T${data.till?.time}`;
  };

  const generateExportData = (itemsData) => {
    const tempList = itemsData?.map((item) => {
      const isActive = item?.status ? 'YES' : 'NO';
      const scheduleInfo = item?.schedule?.always
        ? 'always active'
        : generateSchedule(item.schedule);

      return {
        ...item,
        active: `"${isActive}"`,
        schedules: `"${scheduleInfo}"`,
      };
    });
    const fields = [
      'name',
      'code',
      'active',
      'value',
      'upto',
      'disclaimer',
      'description',
      'schedules',
    ];
    return tempList.map((record) =>
      Object.fromEntries(
        Object?.entries(record)?.filter(([key, value]) =>
          fields?.includes(key) ? [key, "'" + value] : null,
        ),
      ),
    );
  };

  const handleExport = () => {
    let selectedValue = discountsList?.filter((discount) => discount?.isChecked);
    let exportData = [];
    let csvName = '';

    const propertyName = selectedHotel?.find((value) => value?.id === hotelId)?.name;

    if (selectedValue?.length === 1) {
      csvName = `${selectedValue[0].name}_ird_discount.csv`;
      exportData = generateExportData(selectedValue);
    } else if (selectedValue?.length > 1) {
      csvName = `${propertyName}_ird_discounts.csv`;
      exportData = generateExportData(selectedValue);
    } else {
      csvName = `${propertyName}_ird_discounts.csv`;
      exportData = generateExportData(discountsList);
    }

    const headers = generateHeaders?.map((header) => header?.label);
    const csvContent = [
      headers.join(','),
      ...exportData?.map((item) =>
        generateHeaders?.map((header) => item[header.key] || '').join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = csvName;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = discountsList?.filter((discount) => discount?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      case 'Export':
        if (selectedDiscount?.length > 0) {
          handleExport();
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = discountsList?.findIndex((item) => item.id === id);
    if (!discountsList[index]?.isChecked) {
      discountsList[index] = { ...discountsList[index], isChecked: true };
    } else {
      discountsList[index].isChecked = !discountsList[index]?.isChecked;
    }
    setDiscountsList([...discountsList]);

    let actionList = discountsList
      ?.filter((discount) => discount?.isChecked)
      .map((status) => status?.status);

    const checkedItems = discountsList?.filter((discount) => discount?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    const isAllSelected = discountsList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    let selectedDiscountList = discountsList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedDiscountList?.some((discount) => discount?.status);
    const isInactive = selectedDiscountList?.some((discount) => !discount.status);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    setDiscountsList([...selectedDiscountList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedDiscountList.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Discount',
    listOfDiscountIds?.length,
    isActive,
  );

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setDiscountsList(
      inRoomDiningDiscounts?.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_DISCOUNT';
      await updateSelectedItemsStatus(
        listOfDiscountIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Discount was not changed',
      );
    }
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_DISCOUNT';
      await deleteSelectedItems(
        listOfDiscountIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', 'Discounts deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Discount',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {warningPopup?.status && (
        <WarningPopup warningPopup={warningPopup} onWarningClose={onCloseWarning} />
      )}
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteDiscount}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Discounts'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Discounts'
          sectionTItle='Menu Configuration'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/Menu+Configs+Discounts.xlsx'}
        />
      </Dialog>
      <SearchBar
        type={IN_ROOM_DINING_DISCOUNTS_CREATE}
        buttonName='Add Discount'
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        setSearchText={handleSearchText}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={discountsList}
        setPlaceHolder={setDiscountsList}
        globalPlaceHolder={inRoomDiningDiscounts}
        setGlobalPlaceHolder={setInRoomDiningDiscounts}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining discount'
        module='IRD_DISCOUNT'
        searchText={searchText}
        setSearch={setSearchText}
        extraSecondaryBtnDisplay={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
        }
        extraSecondaryBtnText='Upload'
        onClickSecondaryBtn={onClickUpload}
        //temporary disable
        // exportBtn
        // exportBtnTitle="Export"
        // headers={generateHeaders}
        // exportData={generateExportData(discountsList)}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading || inRoomDiningLoader ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          discountsList && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedDiscountLength}
                        totalLength={inRoomDiningDiscounts?.length}
                        inputProps={{
                          'aria-label': 'select all Discount',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Name</TableCell>
                    <TableCell className='w-15'>Discount Code</TableCell>
                    <TableCell className='w-20' align='right'>
                      Discount Value
                    </TableCell>
                    <TableCell className='w-20' align='right'>
                      Discount Price
                    </TableCell>
                    <TableCell className='w-20' align='center'>
                      Status
                    </TableCell>
                    <TableCell className='kebab-menu' align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      discountsList,
                      setDiscountsList,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='services' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? discountsList.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : discountsList
                        ).map((discountKey, i) => (
                          <Draggable
                            key={discountKey.id}
                            draggableId={discountKey.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(discountKey, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(discountKey?.id)}
                                    checked={discountKey?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select discount ${discountKey?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-30'>{discountKey?.name}</TableCell>
                                <TableCell className='w-15'>{discountKey?.code}</TableCell>
                                <TableCell className='w-20' align='right'>
                                  {discountKey?.value}%
                                </TableCell>
                                <TableCell className='w-20' align='right'>
                                  {currency + ' '} {discountKey?.upto}
                                </TableCell>
                                <TableCell className='w-20' align='center'>
                                  <div className='d-flex justify-content-center'>
                                    <div
                                      className={`${
                                        discountKey?.status ? 'pill-active ' : 'pill-inactive '
                                      } pill d-flex justify-content-center align-items-center`}
                                    >
                                      <span className='ms-1'>
                                        {!discountKey?.status ? 'Inactive' : 'Active'}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, discountKey);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={discountKey.id}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === discountKey.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onToggleStatus(e);
                                      }}
                                    >
                                      {selectedValue.discount && selectedValue.discount.status ? (
                                        <>
                                          <RemoveCircleIcon className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, IN_ROOM_DINING_DISCOUNTS_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onViewDetailsFromMenu(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickDelete(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={discountsList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedDiscountLength} ${
              selectedDiscountLength > 1 ? 'discounts' : 'discount'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}
        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedDiscountLength}  ${
              selectedDiscountLength > 1 ? 'discounts' : 'discount'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}{' '}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            onClose={handleBulkSearchAlertClose}
            message="If you perform a search after making selections, the items you've selected will be lost."
            ButtonName='Cancel'
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default DiscountsListView;
